import {randomId,View} from "vritra";
import css from "./ProduceView.module.css";


export default function ProduceView(props){
    const {parent,id=randomId("produceview"),produce}=props,{discount,price}=produce;
    const produceview=View({parent,id,className:css.produceview});

    produceview.innateHTML=`
        ${discount&&`
            <h3 class="${css.discount}">-${discount*100}%</h3>
        `}
        <div class="${css.background}" style="background-image:url(${produce.image})"></div>
        <div class="${css.foreground}">
            <img class="${css.image}" alt="${produce.name}" src="${produce.image}"/>
            <span class="${css.price}">${discount?price*(1-discount):price} $</span>
        </div>
    `;

    return produceview;
}
